/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 19:59:48
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-02 11:42:07
 * @name: 本地存储
 * @Description: 本地存储,长期存在
 * @FilePath: \project\src\storage\localstorage.js
 * @Author: DESKTOP-1QU67QM
 */
const localstorage = class {
    constructor() {
        this.local_title = 'preSaleNafterSaleInside_';
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取localStorage
     * @param {String} key 获取数据键
     */
    get(key) {
        return localStorage.getItem(`${this.local_title}${key}`);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置localStorage
     * @param {String} key 设置数据键
     * @param {Any} value 设置数据值
     */
    set(key, value) {
        return localStorage.setItem(`${this.local_title}${key}`, value);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 移除localStorage
     * @param {String} key 移除数据键
     */
    remove(key) {
        return localStorage.removeItem(`${this.local_title}${key}`);
    }
}

export default localstorage;